import { render, staticRenderFns } from "./leagueDetail.vue?vue&type=template&id=128952ee&scoped=true&"
import script from "./leagueDetail.vue?vue&type=script&lang=ts&"
export * from "./leagueDetail.vue?vue&type=script&lang=ts&"
import style0 from "./leagueDetail.vue?vue&type=style&index=0&id=128952ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128952ee",
  null
  
)

export default component.exports